import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  useForm,
} from "react-hook-form";
import { useCustomMutation, useInvalidate } from "@refinedev/core";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { EditablePriceRow } from "./EditablePriceRow";
import { useParams } from "react-router";

type NewPriceRowProps = {
  onClose: () => void;
};

export const NewPriceRow = (props: NewPriceRowProps) => {
  const { onClose } = props;
  const { translate } = useTranslation("pages.shipmentPrices.details");
  const { countryId, carrierId, serviceId } = useParams<{
    countryId: string;
    carrierId: string;
    serviceId: string;
  }>();

  const methods = useForm({
    mode: "onChange",
  });
  const { handleSubmit } = methods;

  const invalidate = useInvalidate();
  const { isLoading, mutate } = useCustomMutation();

  const onSubmit: SubmitHandler<FieldValues> = (data) => {
    mutate(
      {
        url: `shipment-prices`,
        method: "post",
        values: {
          desi: data.desi,
          price: data.price,
          countryId: Number(countryId),
          carrierId: Number(carrierId),
          carrierServiceId: Number(serviceId),
        },
        successNotification: () => {
          return {
            message: translate("successCreate"),
            type: "success",
          };
        },
      },
      {
        onSuccess: () => {
          invalidate({
            resource: "all",
            invalidates: ["all"],
          });

          onClose();
        },
      }
    );
  };

  return (
    <FormProvider {...methods}>
      <EditablePriceRow
        editDesi
        isLoading={isLoading}
        onClose={onClose}
        onSave={handleSubmit(onSubmit)}
      />
    </FormProvider>
  );
};
